<!-- @format -->

<template>
	<!-- 在 van-search 外层增加 form 标签，且 action 不为空，即可在 iOS 输入法中显示搜索按钮。 -->
	<form v-if="isShowSearchInput && searchInput" action="/">
		<van-search
			v-model="searchFormDatas[searchInput.code]"
			show-action
			shape="round"
			:placeholder="(searchInput.pcProps && searchInput.pcProps.placeholder) || '请输入搜索关键词'"
			:clearable="false"
			@search="onSearch"
		>
			<template #action>
				<van-icon v-if="searchList && searchList.length > 0" name="bars" size="20" @click="showTop = true" />
			</template>
		</van-search>
	</form>
	<div
		v-if="searchList && searchList.length > 0 && !(isShowSearchInput && searchInput)"
		class="van-search search-input"
	>
		<van-icon name="bars" size="20" @click="showTop = true" />
	</div>
	<van-popup v-model:show="showTop" position="top" style="max-height: 70%">
		<div class="more-search-popup">
			<h2 class="more-search-title">高级搜索</h2>
			<van-cell-group inset>
				<template v-for="item in searchList" :key="item.code">
					<van-field
						:name="item.code"
						:label-width="labelAuto ? 'auto' : item.colProps && item.colProps.width ? item.colProps.width : labelWidth"
						:label-align="item.colProps && item.colProps.align ? item.colProps.align : labelAlign"
						:input-align="item.colProps && item.colProps.align ? item.colProps.align : labelAlign"
					>
						<template #label> {{ item.label }}: </template>
						<template #input>
							<slot name="search-cpt-front" v-bind="item"></slot>
							<slot
								name="search-cpt"
								v-bind="item"
								:model-value="searchFormDatas[item.code]"
								:update:model-value="(e:any) => (searchFormDatas[item.code] = e)"
							>
								<component
									:is="getComponentMobile(item.type)"
									v-model="searchFormDatas[item.code]"
									v-bind="item.pcProps"
								/>
							</slot>
							<slot name="search-cpt-backend" v-bind="item"></slot> </template
					></van-field>
				</template>
			</van-cell-group>
			<div class="search-btn">
				<van-button round class="btn" @click="onReset">重置</van-button>
				<van-button round type="primary" class="btn" @click="onSearch"> 提交 </van-button>
			</div>
		</div>
	</van-popup>
</template>

<script lang="ts" setup>
	import type { ComponentType } from './types';
	import { getComponentMobile } from '@/components';

	interface Props {
		modelValue: Record<string, any>;
		isShowSearchInput?: boolean;
		searchInput?: ComponentType;
		searchList?: ComponentType[];
		labelAuto?: boolean;
		labelWidth?: string | number;
		labelAlign?: string;
	}

	const props = withDefaults(defineProps<Props>(), {
		isShowSearchInput: true,
	});

	const showTop = ref(false);
	const emit = defineEmits(['on-search', 'on-search-reset', 'update:modelValue']);

	const searchFormDatas = computed({
		get() {
			return props.modelValue;
		},
		set(val) {
			emit('update:modelValue', val);
		},
	});

	const onSearch = () => {
		showTop.value = false;
		emit('on-search', searchFormDatas.value);
	};

	const onReset = () => {
		searchFormDatas.value = {};
		emit('on-search-reset');
	};
</script>

<style lang="scss" scoped>
	.search-input {
		justify-content: flex-end;
		height: 54px;
	}

	.more-search-popup {
		padding-bottom: 20px;
		background: #f0f0f0;

		.more-search-title {
			margin: 0;
			padding: 16px;
			color: var(--van-doc-text-color-4);
			font-weight: 400;
			font-size: 14px;
			line-height: 16px;
		}

		.search-btn {
			margin-top: 10px;
			text-align: center;

			.btn {
				width: 30%;
			}

			.btn:not(:last-child) {
				margin-right: var(--van-padding-md);
			}
		}
	}
</style>
